"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.primary = '#38C65C';
exports.danger = '#FF0000';
exports.gray = {
    0: '#E5E5E5',
    1: '#C4C4C4',
    2: '#989898',
};
//# sourceMappingURL=index.js.map